import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Masonry } from '@prof-dev/masonry';
gsap.registerPlugin(ScrollTrigger);

jQuery(($) => {
    let stagger = 0.3;

    let showThumbnail = (item, pointer = 1) => {
        const thumbnail = item.querySelector('.wp-post-image');
        gsap.to(item, {
            y: 0,
            opacity: 1,
            duration: 0.7,
            stagger: 0.1,
            overwrite: true,
            delay: pointer * stagger,
            onComplete: () => {
                item.classList.add('masonry-entry--visible');
            }
        });
        if (thumbnail) {
            gsap.to(thumbnail, {
                scale: 1,
                duration: 0.4,
                ease: 'power2.out',
                overwrite: true,
                stagger: 0.1,
                delay: (pointer * stagger) + 0.55,
            });
            gsap.to(thumbnail, {
                opacity: 1,
                duration: 0.5,
                ease: 'power1.inOut',
                stagger: 0.1,
                delay: (pointer * stagger) + 0.55,
            });
        }
    }

    let showItems = (elements) => elements.forEach(showThumbnail);

    let revealItems = (items) => {
        return new Promise(resolve => {
            if (Array.isArray(items) || items instanceof NodeList) {
                items.forEach(item => {
                    const thumbnail = item.querySelector('.wp-post-image');
                    gsap.set(item, {opacity: 0, y: 50});
                    if (thumbnail) gsap.set(thumbnail, {scale: 1.2, opacity: 0});
                });
                showItems(items);
            }
            resolve(true);
        });
    }

    let setStickyLeadElemHeight = (leadFeature, postImage) => {
        const postImageHeight = postImage.offsetHeight;
        const margin = 20;
        let vpHeight = document.documentElement.clientHeight;
        let sectionMargin = parseInt(window.getComputedStyle(leadFeature.closest('.layout--sticky-masonry')).paddingTop);
        let featureHeight = leadFeature.offsetHeight + sectionMargin;
        let previousImg = leadFeature
            ?.closest('.swiper-slide')
            ?.previousElementSibling
            ?.querySelector('img');
        let excess = featureHeight - (vpHeight - margin);
        let calculatedHeight = postImageHeight - Math.abs(excess);

        if (typeof previousImg != 'undefined' && previousImg !== null) {
            if (previousImg.offsetHeight < calculatedHeight) {
                calculatedHeight = previousImg.offsetHeight;
            }
        }
        
        if (featureHeight > (vpHeight - margin)) {
            // Make the image shorter to accommodate the content in the viewport height
            postImage.style.setProperty('height', calculatedHeight.toString() + 'px');
        } else {
            postImage.style.removeProperty('height'); // Height exists to accommodate the content in the viewport height with natural layout
        }
    }

    let setMasonryLeadHeight = (stickyMasonry) => {
        const breakpoints = {
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200,
            xxl: 1366,
            xxxl: 1600
        };
        // Get all slides in the lead feature slider
        const leadFeatureCarousel = stickyMasonry.querySelector('.js-featured-work-carousel');
        // If the lead feature exists in the sticky masonry grid
        if (leadFeatureCarousel) {
            const carouselPagination = leadFeatureCarousel.querySelector('.swiper-pagination');
            const leadFeatureSlides  = leadFeatureCarousel.querySelectorAll('.swiper-slide');
            const breakpoint         = leadFeatureCarousel.closest('.sticky-elem').getAttribute('data-sticky-bp');

            for (const slide of leadFeatureSlides) {
                // For each slide, get the image and set the height based on viewport height if needed
                const postImage    = slide.querySelector('img');
                const leadFeature  = slide.querySelector('.blog-entry--lead-feature');
                if (postImage) {
                    postImage.style.removeProperty('height'); // Reset so we can get the original height
                    // Check if we need to set a height ot not
                    if (typeof breakpoint !== 'undefined' && breakpoint !== null) {
                        if (document.documentElement.clientWidth >= breakpoints[breakpoint]) {
                            setStickyLeadElemHeight(leadFeature, postImage);
                        }
                    } else {
                        setStickyLeadElemHeight(leadFeature, postImage);
                    }
                }
            }
            // Set pagination relative to screen height
            if (carouselPagination) {
                carouselPagination.style.setProperty('bottom','10px');
            }
        }
    }

    let masonryLoad = (grid, items) => {
        return new Promise(resolve => {
            window.imagesLoaded(grid, () => {
                new Masonry(grid);
                resolve(revealItems(items, grid));
            });
        })
    }

    let masonryReload = (grid, items) =>  {
        if (Array.isArray(items) || items instanceof NodeList) {
            //let grid_id = grid.getAttribute('id');
            let isComplete = 0;
            let imageCount = 0;
            items.forEach((item) => {
                let image = item.querySelector('img');
                if (null !== image) {
                    imageCount++;
                }
            });
            items.forEach((item) => {
                // noinspection JSUnresolvedReference
                let loaded = $(item).imagesLoaded();
                loaded.progress((instance, image)  => {
                    // noinspection JSUnresolvedReference
                    if (image.isLoaded) {
                        item.classList.add('image-loaded')
                        isComplete++;
                    }
                });
            })
            // Poll for completed image loaded
            let interval = setInterval(() => {
                if (isComplete >= imageCount) {
                    clearInterval(interval);
                    // noinspection JSUnresolvedReference
                    //items.forEach(item => isotopes[grid_id].appended(item));
                    setTimeout(() => {
                        new Masonry(grid); //isotopes[grid_id].layout();
                        items.forEach((el, index) => showThumbnail(el, index + 1))
                    }, 200);
                }
            }, 100);
        }
    };

    document
        .querySelectorAll('.blog-masonry-grid')
        .forEach((grid) =>
            masonryLoad(grid, grid.querySelectorAll('.masonry-entry')));

    document.addEventListener(
        "masonry-load",
        () => {
            document
                .querySelectorAll('.blog-masonry-grid')
                .forEach((grid) =>
                    masonryLoad(grid, grid.querySelectorAll('.masonry-entry')));
        }
    );

    document.addEventListener(
        "masonry-reload",
        (event) => {
            let grids = document.querySelectorAll('.blog-masonry-grid');
            if (0 < grids.length) {
                masonryReload(
                    grids[grids.length - 1],
                    event?.detail?.items ?? grids[grids.length - 1].querySelectorAll('.masonry-entry'));
            }
        }
    );
    document.querySelectorAll('.js-sticky-masonry').forEach(stickyMasonry => {
        setMasonryLeadHeight(stickyMasonry);
    });
    
    if (document.querySelectorAll('.js-sticky-masonry').length) {
        let previousWidth  = window.innerWidth;
        let previousHeight = window.innerHeight;

        function handleViewportChange() {
            const currentWidth = window.innerWidth;
            const currentHeight = window.innerHeight;
            if (currentWidth !== previousWidth || currentHeight !== previousHeight) {
                previousWidth = currentWidth;
                previousHeight = currentHeight;
                document.querySelectorAll('.js-sticky-masonry').forEach(stickyMasonry => {
                    setMasonryLeadHeight(stickyMasonry);
                });
            }
        }

        function vpDebounce(callback, delay) {
            let timeoutId;
            return function () {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(() => {
                callback.apply(this, arguments);
                }, delay);
            };
        }
        
        window.addEventListener('resize', vpDebounce(handleViewportChange, 200));
    }
});